<template>
  <div class="container companies-insterested">
    <div class="row">
      <div class="col-12">
        <div class="cp-hp-title">
          {{ cpLang("homepage.company_interest") }}
        </div>
      </div>
    </div>
    <no-ssr>
      <swiper
        ref="comSwiper"
        :options="swiperOptions"
        class="companies-swiper"
      >
        <swiper-slide
          v-for="(company, idx) in companies"
          :key="idx"
        >
          <div class="home-company-card">
            <div class="col-sm-4">
              <a :href="companyLink(company.companyname)" class="cp-card-title">
                <img :src="company.logo" alt="">
              </a>
            </div>
            <div class="col-sm-8 text-left">
              <a :href="companyLink(company.companyname)" class="cp-card-title">
                {{ company.companyname }}
              </a>
              <Folcompanybtn
                :logo-id="company.logoid"
                :is-logined="isLogin"
                check-follow
              />
              <div class="cp-card-tag">
                <div class="re-comp-ind l-flex l-align-center">
                  <small class="">{{ company.industrydesc ? company.industrydesc : 'no industry' }}</small>
                </div>
              </div>
              <div v-html="limitedDesc(company.description, companyLink(company.companyname))" class="cp-card-desc" />
            </div>
          </div>
        </swiper-slide>
        <div slot="pagination" class="companies-swiper-pagination" />
      </swiper>
    </no-ssr>
  </div>
</template>

<script>
import Folcompanybtn from '@/components/search/Folcompanybtn'
import commonFunc from '~/assets/js/commonHelper.js'

export default {
  components: {
    Folcompanybtn
  },
  props: {
    isLogin: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      companies: null
    }
  },
  computed: {
    swiperOptions() {
      return {
        slidesPerView: 2,
        breakpoints: {
          1024: {
            slidesPerView: 2,
            spaceBetween: 30
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 20
          },
          568: {
            pagination: false
          },
          0: {
            slidesPerView: 1,
            spaceBetween: 10,
            pagination: {
              el: '.companies-swiper-pagination'
            }
          }
        }
      }
    }
  },
  mounted() {
    this.getCompanies()
  },
  methods: {
    getCompanies: async function () {
      const vm = this
      await this.$axios.get('companies/recommendation').then(function(resp) {
        vm.companies = resp.data.companies
      })
    },
    limitedDesc: function(str, url) {
      const smmd = window.innerWidth > 576 && window.innerWidth < 1024
      if (str) {
        if (!smmd) {
          if (str.length > 170) {
            return `${str.substring(0, 180)}...<a href="${url}">more</a>`
          } else {
            return str
          }
        } else {
          const strl = str.length
          if (strl > 60) {
            return `${str.substring(0, 70)}...<a href="${url}">more</a>`
          } else {
            return str
          }
        }
      }
    },
    companyLink(name) {
      const slug = commonFunc.getSlug(name)
      return '/company-' + slug + '-jobs/1'
    }
  }
}
</script>

<style lang="scss">
.home-company-card{
  width: 100%;
  .folbtn {
    border:0;
    color: #fff;
    border-radius: 5px !important;
    z-index: 2;
    padding: 1px 7px;
    font-size: 12px;
     margin: 0;
  }
}
.companies-swiper{
  .swiper-wrapper{
    .swiper-slide{
      margin-bottom: 20px;
      display: flex;
      height: auto !important;
    }
  }
  .swiper-pagination-bullet{
    width: 14px;
    height: 14px;
    &.swiper-pagination-bullet-active{
      background:#0EA5BF;
    }
  }
}
.re-comp-ind{
  position: relative;
  padding: 10px 0px 10px 25px;
  &:before{
  content: '';
    position: absolute;
    background: url(/asset/image/icon/briefcase.png) #00CDA7 no-repeat;
    background-position: center 4px;
    width: 20px;
    height: 20px;
    background-size: 12px;
    border-radius: 30px;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
  }
}
</style>
